var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPay3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 24,
    viewBox: "0 0 39 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_35_417)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.6597 2.56262H14.1626V21.4274H24.6597V2.56262Z",
    fill: "#FF5F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8292 11.9966C14.8282 10.1807 15.2403 8.38829 16.0341 6.75504C16.8279 5.12179 17.9827 3.69044 19.4112 2.56924C17.6414 1.17836 15.516 0.313461 13.2779 0.0733816C11.0398 -0.166698 8.77932 0.227731 6.75478 1.21159C4.73024 2.19545 3.02334 3.72904 1.82917 5.63709C0.634987 7.54515 0.00170898 9.75068 0.00170898 12.0016C0.00170898 14.2526 0.634987 16.4581 1.82917 18.3661C3.02334 20.2742 4.73024 21.8078 6.75478 22.7916C8.77932 23.7755 11.0398 24.1699 13.2779 23.9299C15.516 23.6898 17.6414 22.8249 19.4112 21.434C17.9808 20.3123 16.8248 18.8794 16.0309 17.2442C15.2369 15.609 14.826 13.8144 14.8292 11.9966V11.9966Z",
    fill: "#EB001B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8224 11.9966C38.8224 14.2477 38.1889 16.4534 36.9945 18.3615C35.8002 20.2697 34.093 21.8032 32.0682 22.7869C30.0434 23.7707 27.7827 24.1648 25.5445 23.9244C23.3062 23.684 21.1808 22.8187 19.4111 21.4274C20.6498 20.4539 21.6846 19.246 22.4565 17.8726C23.2283 16.4992 23.7221 14.9872 23.9097 13.4229C24.0972 11.8587 23.9748 10.2728 23.5494 8.75592C23.124 7.239 22.4041 5.82071 21.4306 4.58203C20.8387 3.83323 20.1609 3.15656 19.4111 2.56592C21.1808 1.17462 23.3062 0.309293 25.5445 0.0688689C27.7827 -0.171556 30.0434 0.22262 32.0682 1.20634C34.093 2.19006 35.8002 3.72362 36.9945 5.63174C38.1889 7.53986 38.8224 9.74553 38.8224 11.9966V11.9966Z",
    fill: "#F79E1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6561 19.4279V19.0413H37.8127V18.9647H37.4229V19.0447H37.5795V19.4312L37.6561 19.4279ZM38.4259 19.4279V18.9614H38.3226L38.1826 19.2946L38.0427 18.9614H37.9194V19.4279H37.9894V19.0947L38.1193 19.3979H38.2093L38.3393 19.0947V19.4479L38.4259 19.4279Z",
    fill: "#F79E1B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_35_417"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38.8226,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPay3);
export default __webpack_public_path__ + "static/media/pay3.12c9eaa705cef10d1cb3198ab975c4e8.svg";
export { ForwardRef as ReactComponent };